<template>
  <div>
    <div class="login">
      <div class="container">
        <div class="logo">
          <a href="#" class="logo-link">
             <img src="/static/images/torepi-logo.png" alt="" class="mb-4 logo-img">
          </a>
        </div>
        <div class="login-box">
          <div class="title-box resetPass">
            <h2 class="pri-title">パスワード再設定</h2>
          </div>
          <form action class="login-box--form">
            <div class="form-group">
              <label for="password" class="label-form">新しいパスワード<span class="required">*</span></label>
              <div class="input-group">
                <input
                  id="password"
                  type="password"
                  name="password"
                  class="input-form"
                  placeholder="新しいパスワードを入力してください"
                  v-model.trim="params.new_password"
                  :class="passwordError()"
                  @input="$v.params.new_password.$touch()"
                />
                <small v-if="!$v.params.new_password.required && invalid" class="text-input error">{{message.PASSWORD_REQUIRED}}</small>
                <small v-if="passwordErrorFormat()" class="text-input error">{{message.PASSWORD_FORMAT}}</small>
              </div>
            </div>
             <div class="form-group">
              <label for="repassword" class="label-form">パスワード再入力<span class="required">*</span></label>
              <div class="input-group">
                <input
                  id="repassword"
                  type="password"
                  name="repassword"
                  class="input-form"
                  placeholder="パスワード再入力を入力してください"
                  v-model.trim="params.confirm_password"
                  :class="confirmPassword()"
                  @input="$v.params.confirm_password.$touch()"
                />
                <small v-if="!$v.params.confirm_password.required && invalid" class="text-input error">{{message.PASSWORD_REQUIRED}}</small>
                <small v-if="confirmPasswordError()" class="text-input error">{{message.PASSWORD_CONFIRM}}</small>
              </div>
            </div>
            <div class="button-group">
              <button
                class="btn btn-rounder btn-primary btn-login"
                type="button"
                v-b-modal.modal-center
                @click="changePassword"
                >パスワード設定
              </button>
            </div>
            <div class="form-footer text-center">
              <p class="text">すでにアカウントをお持ちですか？ <a class="link"><router-link :to="{name: 'login'}">ここ</router-link></a>でログイン</p>
            </div>
          </form>
        </div>
        <div class="copyright">
          <span>株式会社SOFTNEXT©2020 All rights reserved</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {MESSAGE} from '@/utils/errorjapanese'
import {required, minLength, maxLength, sameAs} from 'vuelidate/lib/validators'
export default {
  name: 'ChangePassword',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  data () {
    return {
      token: this.$route.params.token,
      message: MESSAGE,
      params: {
        new_password: '',
        confirm_password: ''
      },
      invalid: false
    }
  },
  validations: {
    params: {
      new_password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
        valid (password) {
          const containsUppercase = /[A-Z]/.test(password)
          const containsLowercase = /[a-z]/.test(password)
          const containsNumber = /[0-9]/.test(password)
          const containsSpecial = /[#?!@$%^&*-]/.test(password)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        }
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs('new_password')
      }
    }
  },
  methods: {
    passwordError () {
      return (!this.$v.params.new_password.required || !this.$v.params.new_password.minLength || !this.$v.params.new_password.maxLength || !this.$v.params.new_password.valid) && this.invalid ? 'error' : ''
    },
    passwordErrorFormat () {
      return (!this.$v.params.new_password.minLength || !this.$v.params.new_password.maxLength || !this.$v.params.new_password.valid) && this.invalid && this.$v.params.new_password.required ? 'error' : ''
    },
    confirmPassword () {
      return (!this.$v.params.confirm_password.required || !this.$v.params.confirm_password.sameAsPassword) && this.invalid ? 'error' : ''
    },
    confirmPasswordError () {
      return !this.$v.params.confirm_password.sameAsPassword && this.invalid && this.$v.params.confirm_password.required
    },
    changePassword (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      this.$store.dispatch('allAuth/changePassword', {token: this.token, new_password: this.params})
    }
  },
  mounted () {
    this.$store.dispatch('allAuth/checkTokenResetPassword', this.token)
  }
}
</script>
<style scoped lang='scss'>
  @import '@/assets/stylesheet/auth/login.scss';
</style>



// WEBPACK FOOTER //
// src/views/Login/ChangePassword.vue